// Do not modify this file, it is generated automatically by the script update-contract-addresses.mjs!

export const addresses = {
	Bit: "0x9ceb6ed22e44ae7ecfe677deb2b63157b4829792",
	Oil: "0xc0bf6533fe18394a581aa38de831c4ecc64cbe55",
	Bot: "0x8e7ac636cf84edd19e7330e279495104903aba11",
	BotMetadata: "0x1abc7a878b1b88fbac4dfc3ad7572d73cb627b20",
	BotRevealer: "0x21e9547b00ff1398bbaf71eb426c669a55993fe5",
	BotTeam: "0xd078aa3a61efd71e5149fe9cc000582bf7140d4b",
	Ship: "0xfd6b6376753458104d711936289fd28e2cf91a92",
	ShipMetadata: "0x1fe7a6703201f2909e062af3d57f74db7667309d",
	ShipRevealer: "0x1fc6ba07d45cf43bc82a272b241344939b087e99",
	ShipTeam: "0x586ea63c174b26bdefca658a0bdbb4cd0fea7476",
	Reward: "0x5bd7689ea80f7bc30cb02844ed9e9b1465b0a3c5",
	AllianceStaking: "0x32fa68c663c9f767e4631dc7d103581e42237ae5",
	BotRent: "0x3abf428ddf17ec312e04fc2c8e586214eb182b4a",
	Marketplace: "0x6468adcef1ae7a00a1712ef6442f1c1f166a0148",
	ShipRent: "0xc1948efee9d968076fcd8943097b5344b9271e6a",
	BotMinter: "0xc9ac93d34b9c85d8b757a024524366ead432dea1",
	BotUpgrader: "0x0f14f0a2ef6b2ebc08b40917f85fff3b7819cb4f",
	ShipMinter: "0xd694da21413895bca869a810329c26a3fb3effac",
	RewardEarlyClaim: "0x52c96e497bf38645f517f7e690a4efb7b2a8ca6b",
	DamageFix: "0xd31ac55506e52c8072900568bde599ab627d4480",
	VotingEscrow: "0x525345b6d0187c60e506c1bad26a25bb7e53deea",
	BotShipPool: "0xc88b4300415cf74100bbb26ccf62c9fea21ef650",
}
